import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from "date-fns";

export const formatCompactAge = (date) => {
  if (!date) return "";

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "";

  const now = new Date();

  const minutes = differenceInMinutes(now, parsed);
  if (minutes < 60) return `${Math.max(minutes, 0)}m`;

  const hours = differenceInHours(now, parsed);
  if (hours < 24) return `${hours}h`;

  return `${differenceInDays(now, parsed)}d`;
};
